export const VnLocalizedStrings = {
  GlobalLabels: {
    All: "Tất cả",
    Logout: "Đăng xuất",
    PleaseWait: "Vui lòng đợi...",
    Status: "Trạng thái",
    Phone: "Số điện thoại",
    Actions: "Hành động",
    Active: "Hoạt động",
    Inactive: "Không hoạt động",
    Deleted: "Xóa",
    IsDeleted: "Đã xoá",
    Search: "Tìm kiếm",
    Redo: "Làm mới bộ lọc",
    Cancel: "Quay lại",
    Confirmed: "Xác nhận",
    Detail: "Chi tiết",
    Create: "Thêm mới",
    Password: "Mật khẩu",
    PasswordConfirmed: "Xác nhận mật khẩu",
    Description: "Mô tả",
    Update: "Cập nhật",
    Address: "Địa chỉ",
    Partner: "Đối tác",
    Total: "Tổng cộng",
    NoPartner: "Không thuộc đối tác",
    createdAt: "Ngày tạo",
    updatedAt: "Ngày cập nhật",
    Cover: "Ảnh nền",
    Success: "Thành công",
    Failed: "Thất bại",
    Date: "Ngày",
    ExcelExporting: "Xuất Excel",
    Type: "Loại",
    Regions: "Vùng",
    Login: "Đăng nhập",
    NoInfo: "Không có thông tin",
    NoSort: "Không theo độ ưu tiên",
    Day: "Ngày",
    ManyDays: "Nhiều ngày",
    Hour: "Giờ",
    ManyHours: "Nhiều giờ",
    ASC: "Tăng dần",
    DESC: "Giảm dần",
    Save: "Lưu",
    Male: "Nam",
    Female: "Nữ",
    Next: "Tiếp",
    Yes: "Có",
    No: "Không",
    ReloadImages: "Làm mới ảnh",
    NoImage: "Không có hình ảnh",
    Row: "Hàng",
    Error: "Lỗi",
    FileList: "Danh sách file",
  },
  GlobalMessage: {
    UpdateSuccessfully: "Cập nhật thành công !",
    UpdateFailed: "Cập nhật thất bại:",
    CreateSuccessfully: "Tạo mới thành công !",
    CreateFailed: "Tạo mới thất bại:",
    DeleteSuccessfully: "Xóa thành công !",
    DeleteFailed: "Xóa thất bại:",
    DeleteConfirmation: "Xác nhận xóa phần tử này ?",
    ResetPassSuccessfully: "Đặt lại mật khẩu thành công !",
    ResetPassFailed: "Đặt lại mật khẩu thất bại:",
    Error: "Đã có lỗi xảy ra, vui lòng thử lại !",
    Exporting: "Đang xuất Báo cáo...",
    SystemError: "Có lỗi lấy thông tin đăng nhập, quay lại trang đăng nhập...",
    LoginSuccessfully: "Đăng nhập thành công !",
    InvalidAccount:
      "Username hoặc mật khẩu không đúng hoặc User không tồn tại !",
    InvalidMenuConfig:
      "Lỗi không lấy được Menu Sidebar, vui lòng thử lại sau !",
    Failed: "Thất bại",
    RequiredBrightness: "Thông số độ sáng yêu cầu tối thiểu là 102",
  },
  GlobalPlaceholder: {
    UserName: "Vui lòng nhập user name...",
    Email: "Vui lòng nhập email...",
    Name: "Vui lòng nhập tên...",
    Code: "Vui lòng nhập mã...",
    Partner: "Vui lòng chọn đối tác",
    Status: "Vui lòng chọn trạng thái",
    Phone: "Vui lòng nhập số điện thoại...",
    Password: "Vui lòng nhập mật khẩu",
    PasswordConfirmed: "Mật khẩu xác nhận cần trùng với mật khẩu",
    Description: "Vui lòng nhập mô tả là chữ",
    InvalidValue: "Vui lòng điền đầy đủ thông tin",
    Type: "Vui lòng chọn loại",
    Date: "Vui lòng chọn ngày",
    InvalidPartnerRole: "Vui lòng chọn Role cho người dùng",
  },
  Sidebar: {
    General: "Tổng quan",
    Management: "Quản lý",
    History: "Lịch sử giao dịch",
    DataTransaction: "Gói cước",
    SystemConfig: "Cấu hình hệ thống",
    DataPackages: "Gói cước Data",
    RoamingPackages: "Gói cước Roaming",
    UserManagement: "Người dùng",
    AffiliateManagement: "Quản lý affiliate",
    OrderList: "Đơn hàng mua sim",
    TravelSimList: "Đăng ký sim du lịch",
    Country: "Quốc gia",
    PlatformConfig: "Platform",
    Contents: "Bài viết",
    Files: "Tệp",
    CDN: "CDN",
    Address: "Tỉnh thành",
  },
  General: {
    Revenue: {
      Day: "Doanh thu hôm nay",
      Week: "Doanh thu tuần này",
      Month: "Doanh thu tháng này",
      LastMonth: "Doanh thu tháng trước",
      WeekOfYear: "Tuần",
    },
    Charts: {
      Title: "Báo cáo tổng hợp",
      Transaction: "Giao dịch",
      TotalRevenue: "Tổng doanh thu",
      SuccessTransaction: "Tổng giao dịch thành công",
    },
  },
  BalanceHistory: {
    Title: "Lịch sử điều chỉnh số dư",
    Approve: "Duyệt",
    Reject: "Từ chối",
    Add: "Tạo phiếu nạp",
    Type: {
      0: "Phiếu tăng",
      1: "Phiếu giảm",
      2: "Phiếu hoàn tiền",
    },
    Status: {
      0: "Đang chờ duyệt",
      1: "Duyệt",
      2: "Từ chối",
      3: "Lỗi",
    },
    ApplicableType: {
      0: "Người dùng",
      1: "Đối tác",
    },
    WalletType: {
      0: "Nội tệ",
      1: "Ngoại tệ",
    },
    Placeholder: {
      Type: "Vui lòng chọn loại phiếu",
      ApplicableType: "Vui lòng chọn đối tượng áp dụng",
      Amount: "Vui lòng nhập số tiền lớn hơn 0",
      Phone: "Vui lòng chọn thông tin người dùng hoặc đối tác ở trên",
      Partner: "Vui lòng chọn một đối tác",
      User: "Vui lòng chọn một người dùng",
      Approve: "Xác nhận duyệt phiếu này",
      Reject: "Xác nhận từ chối phiếu này"
    },
    Columns: {
      createdAt: "Ngày tạo",
      updatedAt: "Ngày cập nhật",
      code: "Mã phiếu",
      userName: "Username",
      phone: "Số điện thoại",
      fullName: "Họ tên",
      email: "Email",
      address: "Địa chỉ",
      userType: "Loại người dùng",
      walletType: "Loại ví",
      before: "Số dư trước khi duyệt",
      after: "Số dư sau khi duyệt",
      amount: "Số tiền yêu cầu",
      wallet: "Số dư hiện tại",
      applicableType: "Đối tượng áp dụng",
      type: "Loại",
      status: "Trạng thái",
      createdBy: "Người tạo",
      updatedBy: "Người duyệt",
      description: "Mô tả",
    },
    Message: {
      CreateSuccessfully: "Tạo phiếu thành công !",
      CreateFailed: "Tạo phiếu thất bại !",
      ApproveSuccessfully: "Duyệt phiếu thành công !",
      ApproveFailed: "Duyệt phiếu thất bại",
      RejectSuccessfully: "Từ chối phiếu thành công !",
      RejectFailed: "Từ chối phiếu thất bại",
      DirectToHistory: "Lịch sử điều chỉnh số dư",
    },
  },
  UserManagement: {
    MainTitle: "Quản lý người dùng",
    Total: "Tổng User",
    Columns: {
      UserName: "Tên tài khoản",
      FullName: "Họ và tên",
      Email: "Email",
      Partner: "Đối tác",
      Phone: "Số điện thoại",
      Balance: "Số dư",
      Role: "Role",
      ResetPass: "Đặt mật khẩu mới",
      OldPass: "Mật khẩu cũ",
      NewPass: "Mật khẩu mới",
      Currency: "Tiền tệ",
    },
    RuleMessage: {
      Url: "Vui lòng nhập link dưới dạng URL HTTPS",
      Name: "Vui lòng nhập tên",
      Password: "Vui lòng nhập mật khẩu",
      UserName: "Vui lòng nhập username",
      IdUrl: "Vui lòng nhập link tiếp thị",
      IconUrl: "Vui lòng nhập link icon có định dạng jpg, png, jpeg",
      Status: "Vui lòng chọn trạng thái",
      Phone: "Vui lòng nhập số điện thoại gồm 10 chữ số",
      Code: "Vui lòng nhập mã",
      Role: "Vui lòng chọn role cho user",
      Partner: "Vui lòng chọn đối tác",
      InvalidPartner: "Đối tác không hợp lệ",
      Balance: "Vui lòng nhập hạn mức",
      ResetYourAccount: "Đã đổi mật khẩu tài khoản của bạn, vui lòng đăng nhập..."
    },
    UserType: {
      Normal: "Người dùng cơ bản",
      SuperAdmin: "Super admin",
      Partner: "Đối tác",
    },
  },
  PathConfigManagement: {
    Title: "Quản lý cấu hình",
    Total: "Tổng cộng",
    Columns: {
      Title: "Tên cấu hình",
      Code: "Mã cấu hình",
      Path: "Đường dẫn",
      ImageUrl: "Hình ảnh",
      Description: "Mô tả",
    },
    Placeholder: {
      Title: "Vui lòng nhập tên",
      Path: "Vui lòng nhập đường dẫn",
      ImageUrl: "Vui lòng nhập link hình ảnh dạng URL",
      Description: "Vui lòng nhập mô tả",
    },
    Message: {
      AddConfig: "Vui lòng khai báo cấu hình JSON bên dưới",
    },
  },
  ContentManagement: {
    Title: "Quản lý bài viết",
    Total: "Tổng bài viết",
    Columns: {
      Name: "Tên bài viết",
      Preview: "Xem trước",
      Replace: "Thay bài viết",
      Download: "Tải bài viết",
      Delete: "Xóa bài viết",
      File: "Tệp bài viết",
      Image: "Hình ảnh",
    },
    Message: {
      WrongStructure: "File tải không đúng định dạng !",
      NotExisted: "File tải không tồn tại !",
      Files: "Vui lòng nhập ít nhất một file bài viết",
      OnlyDocx: "Lưu ý: Chỉ nhập file DOCX",
      OnlyImages: " Lưu ý: Chỉ nhập 1 file ảnh PNG, JPEG, JPG",
      MissingAttributes:
        "Vui lòng đặt tên có tiền tố Content đối với file DOC hoặc Image đối với file ảnh !",
      AddAttribute:
        "Vui lòng đặt tên file bài viết có tiền tố Content (Content_abc.docx), file hình ảnh có tiền tố Image (Image_xyz.png)",
    },
  },
  CountryManagement: {
    Title: "Quản lý quốc gia",
    Total: "Tổng quốc gia",
    Columns: {
      Name: "Tên quốc gia",
      Code: "Mã quốc gia",
      Capital: "Thủ đô",
      Region: "Vùng",
      Ensign: "Quốc kỳ",
    },
    Regions: {
      SouthAmerica: "Nam Mỹ",
      NorthAmerica: "Bắc Mỹ",
      NorthPole: "Nam Cực",
      Europe: "Châu Âu",
      Asia: "Châu Á",
      Africa: "Châu Phi",
      Australia: "Châu Đại Dương",
      Asean: "Đông Nam Á",
    },
    Placeholder: {
      Capital: "Vui lòng nhập tên thủ đô",
      Region: "Vui lòng chọn vùng quốc gia",
      Cover: "Vui lòng nhập link hình ảnh dưới dạng URL",
    },
    RoamingPartner: {
      Name: "Tên đối tác",
      Code: "Mã đối tác",
    },
    MobileData: {
      Name: "Tên gói cước",
      Code: "Mã gói cước",
      Price: "Giá gói",
      Handset: "Handset",
      TransferredData: "Nhóm dữ liệu",
      CodeMobileDevice: "Code Mobile Device",
    },
    Message: {
      CoverAttributes: "Vui lòng đặt tên file cover có tiền tố Cover_",
      EnsignAttributes: "Vui lòng chọn một file ảnh quốc kỳ !",
    },
  },
  FileManagement: {
    Title: "Quản lý CDN",
    Upload: "Nhập File",
    Replace: "Thay file",
    Download: "Tải file",
    CopyUrl: "Sao chép URL",
    Placeholder: {
      Type: "Vui lòng chọn loại file",
      File: "Vui lòng nhập ít nhất 1 file từ máy tính",
      Url: "Đã lưu URL vào bộ nhớ tạm",
    },
    Columns: {
      Name: "Tên file",
      Code: "Mã file",
      Size: "Kích thước",
      Type: "Loại tệp",
    },
  },
  RoamingManagement: {
    Title: "Quản lý Gói Roaming",
    Total: "Tổng gói Roaming",
    Add: "Thêm",
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
      Roaming: "Gói Roaming",
    },
    PlaceHolder: {
      Cover: "Vui lòng nhập url hình ảnh...",
      Descriptions: "Vui lòng nhập mô tả...",
      ShortDes: "Vui lòng nhập mô tả ngắn gọn...",
      Duration: "Vui lòng nhập thời lượng gói...",
      Price: "Vui lòng nhập giá gói...",
      Storage: "Vui lòng nhập dung lượng gói...",
      DiscountRate: "Vui lòng nhập giảm giá...",
      InternalCallTotalHour: "Vui lòng nhập giờ gọi nội mạng...",
      ExternalCallTotalHour: "Vui lòng nhập giờ gọi ngoại mạng...",
      Category: "Vui lòng chọn loại gói...",
      Country: "Vui lòng chọn quốc gia...",
    },
    Country: {
      Title: "Quốc gia",
      Add: "Thêm quốc gia",
      Edit: "Chỉnh sửa thông tin quốc gia",
    },
    RoamingPartner: {
      Title: "Đối tác",
      Add: "Thêm đối tác",
      Select: "Chọn đối tác",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã",
      Cover: "Hình ảnh",
      Description: "Mô tả",
      ShortDescription: "Mô tả ngắn gọn",
      Duration: "Thời lượng gói",
      Price: "Giá",
      Storage: "Dung lượng",
      DiscountRate: "Giảm giá",
      InternalCallTotalHour: "Giờ gọi nội mạng",
      ExternalCallTotalHour: "Giờ gọi ngoại mạng",
      Action: "Hành động",
      Country: "Quốc gia",
      Region: "Khu vực",
      Category: "Loại gói",
      Order: "Thứ tự",
      Type: "Loại",
      SimType: "Loại Sim",
    },
  },
  TopupManagement: {
    Title: "Quản lý gói cước Data",
    Total: "Tổng gói cước",
    Add: "Thêm thông tin",
    AddShort: "Thêm mô tả ngắn",
    AddMore: "Thêm thông tin chi tiết gói",
    More: "Thông tin chi tiết gói",
    MoreInfoName: "Tên thông tin",
    MoreInfoItems: "Thông tin",
    ShortDescription: "Mô tả ngắn",
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      DurationDay: "Thời hạn",
      Price: "Giá gói",
      Storage: "Dung lượng",
      Category: "Loại gói",
      Order: "Điểm ưu tiên",
      InternalCallTotalHour: "Gọi nội mạng",
      ExternalCallTotalHour: "Gọi ngoại mạng",
    },
    Category: {
      Hot: "Gói hot",
      Day: "Gói ngày",
      Week: "Gói tuần",
      Month: "Gói tháng",
    },
    Placeholder: {
      DurationDay: "Vui lòng nhập thời lượng gói",
      Price: "Vui lòng nhập giá gói thấp nhất 1,000 VND !",
      Storage: "Vui lòng nhập dung lượng là số !",
      Cover: "Vui lòng nhập link ảnh dưới dạng URL !",
      Category: "Vui lòng chọn loại gói cước",
    },
    SyncFromB2B: {
      Title: "Thêm gói data từ B2B",
      Confirm: "Bạn có chắc chắn muốn thêm các gói",
      InvalidPackages: "Vui lòng chọn một gói cước",
    },
  },
  TransactionHistory: {
    Title: "Lịch sử giao dịch gói cước",
    Total: "Tổng giao dịch",
    NoTransRef: "Không mã tham chiếu",
    UpdateStatus: "Cập nhật trạng thái",
    UpdateStatusSuccess: "Cập nhật trạng thái thánh công",
    Customer: "Khách hàng mua lẻ",
    Details: "Chi tiết giao dịch",
    Message: {
      PartnerListError: "Lỗi danh sách đối tác",
    },
    Status: {
      Init: "Khởi tạo",
      Progerssing: "Đang xử lý",
      Finished: "Hoàn thành",
      Error: "Lỗi",
      Deleted: "Đã xóa",
      WaitingToBeConfirmed: "Chờ xác nhận",
    },
    Placeholder: {
      Code: "Nhập mã giao dịch",
      ID: "Nhập ID giao dịch",
      TransRef: "Nhập mã tham chiếu",
    },
    Columns: {
      ID: "ID giao dịch",
      Code: "Mã giao dịch",
      TransRef: "Mã tham chiếu",
      PackageName: "Tên gói",
      Phone: "Số điện thoại",
      RegisteredPhone: "Thuê bao đăng ký",
      Partner: "Đối tác",
      Method: "Phương thức",
      TotalAmount: "Tổng tiền",
    },
  },
  AddressManagement: {
    Title: "Quản lý Tỉnh thành",
    DataType: "Dữ liệu danh sách",
    Province: "Danh sách Tỉnh, Thành phố lớn",
    District: "Danh sách Quận, Huyện",
    Wards: "Danh sách Phường, Xã",
    Columns: {
      Name: "Tên",
      Code: "Mã",
      FullName: "Tên đầy đủ",
      FullNameEn: "Tên tiếng Anh đầy đủ",
      Province: "Tỉnh, thành phố lớn",
      District: "Quận, huyện",
      NameEn: "Tên tiếng Anh",
      Ward: "Phường, xã",
    },
    Placeholder: {
      Units: "Vui lòng chọn loại",
      Regions: "Vui lòng chọn vùng",
    },
  },
  ChangePassword: {
    Title: "Đổi mật khẩu",
    OldPass: "Mật khẩu cũ",
    NewPass: "Mật khẩu mới",
    Reconfirmed: "Xác nhận mật khẩu mới",
    Message: {
      InvalidPass: "Vui lòng xác nhận mật khẩu",
      OldPass: "Vui lòng nhập mật khẩu cũ",
      NewPass: "Vui lòng nhập mật khẩu mới",
      UnmatchedPass: "Mật khẩu xác nhận không trùng khớp",
      ChangePassSucceed: "Bạn đã đổi mật khẩu thành công !",
    },
  },
  SimOrdersForPartners: {
    Title: "Tra cứu thông tin sim",
    OrderInfo: "Thông tin đơn hàng",
    Columns: {
      CreatedAt: "Thời gian tạo",
      OrderCode: "Mã đơn hàng",
      Sim: "Số Sim",
      Serial: "Số Serial",
      PackageType: "Loại gói",
      CustomerName: "Tên khách hàng",
      CustomerPhone: "SĐT khách hàng",
      Address: "Địa chỉ giao hàng",
      Email: "Email khách hàng",
      Partner: "Đối tác",
      Status: "Trạng thái",
      Detail: "Chi tiết đơn hàng",
      ActivatedTime: "Thời gian kích hoạt",
      ConnectedTime: "Thời gian đấu nối",
      Type: "Loại",
      Name: "Tên đơn hàng",
      TotalAmount: "Tổng tiền",
      PhoneNumber: "Số điện thoại",
      SimItems: "Danh sách sim",
    },
    Status: {
      WaitingForPurchased: "Chờ thanh toán",
      WaitingForDelivered: "Chờ giao hàng",
      WaitingForRecieved: "Chờ nhận hàng",
      Success: "Giao hàng thành công",
      Canceled: "Đã hủy",
      ConnectedSuccessfully: "Hòa mạng thành công",
      ConnectedFailed: "Hòa mạng thất bại",
      Items: {
        Import: "Đã nhập kho",
        Export: "Đã xuất kho",
        Connected: "Đã đấu nối",
        Activated: "Đã kích hoạt",
        Destroyed: "Đã hủy",
        Held: "Đang giữ",
      },
      Order: {
        Init: "Khởi tạo",
        Progress: "Đang xử lý",
        Finished: "Thành công",
        Error: "Lỗi",
        Deleted: "Hủy",
        ShippingOrder: "Đang giao hàng",
        WaitingPayment: "Chờ thanh toán",
      },
    },
    Type: {
      Init: "Khởi tạo",
      Active: "Kích hoạt",
      Kyc: "Đấu nối",
      Transfer: "Chuyển kho",
    },
    Message: {
      ExcelError: "Lỗi xuất báo cáo",
      InvalidSim: "Số sim không được để trống",
      InvalidPackages: "Nhập số sim để hiện thông tin gói",
      InvalidOrderCode: "Mã đơn hàng không để trống",
      InvalidPhone: "Điện thoại liên hệ không được trống hoặc quá 10 số !",
      Address: "Vui lòng nhập địa chỉ khách hàng",
    },
  },
  TravelSimListManagement: {
    Title: "Danh sách thông tin đăng ký sim du lịch",
    Placeholder: "Vui lòng nhập ",
    Detail: "Thông tin chi tiết",
    Gender: {
      Male: "Nam",
      Female: "Nữ",
      Other: "Khác",
    },
    Labels: {
      ProfileStatus: "Tình trạng hồ sơ",
      BrightnessScore: "Độ sáng:",
      OCRNow: "OCR chân dung, mặt trước và videocall",
      Status: "Trạng thái",
      Type: "Loại giấy tờ",
      Name: "Tên khách hàng",
      ProfileId: "Mã hồ sơ",
      Serial: "Số serial",
      Sim: "Số sim",
      Detail: "Chi tiết",
      Time: "Thời gian tạo",
      IdNumber: "Mã định danh",
      Birthday: "Ngày sinh",
      Sex: "Giới tính",
      Address: "Địa chỉ",
      PlaceOfOrigin: "Nguyên quán",
      IssueDate: "Ngày cấp",
      IssuePlace: "Nơi cấp",
      PhoneContact: "Số điện thoại",
      EmailContact: "Email",
      ImagesPath: "Các loại giấy tờ",
      DialCode: "Khu vực",
      Nationality: "Quốc tịch",
      ConnectedTime: "Thời gian kết nối",
      Reason: "Lý do cập nhật",
      DownloadFile: "Tải ảnh",
      UpdateStatus: "Đổi trạng thái hồ sơ",
      Connect: "Đấu nối hồ sơ",
      CreateProfile: "Tạo bộ hồ sơ",
      VideocallGenate: "Tạo hình videocall",
      SubmitInfo: "Thông tin",
      ConfirmInfo: "Xác nhận",
      UploadImage: "Tải ảnh lên",
      UploadNote: "Chọn tệp để tải lên",
      UploadHint: "Chỉ có thể tải lên 1 hình ảnh",
      UploadAgain: "Chọn tệp tải lại",
      Passport: "Hộ chiếu",
      Portrait: "Chân dung",
      Videocall: "Videocall",
      QRSim: "Ảnh sim",
      SignPad: "Chữ ký",
      ClearSignature: "Xóa chữ ký",
      Complete: "Hoàn thành",
      SelectVideocall: "Chọn videocall",
      SignDirect: "Ký trực tiếp",
      UploadSign: "Tải chữ ký",
      SimTracking: "Tra cứu sim",
      Platform: "Loại",
      UploadMultiple: "Đấu lô hồ sơ",
      Images: "Hình ảnh",
      MissingImages: "Danh sách hình bị thiếu",
      ViewMultipleFile: "Xem file đấu lô",
    },
    ImagePaths: {
      portrait: "Ảnh chân dung",
      videocall: "Videocall",
      front: "Mặt trước",
      back: "Mặt sau",
      sign: "Chữ ký",
      sim: "Sim",
      contract: "Hợp đồng",
      policy: "Điều khoản bảo mật",
      front_downscale: "Mặt trước thu nhỏ",
      portrait_downscale: "Chân dung thu nhỏ",
      videocall_downscale: "Video call thu nhỏ",
    },
    Status: {
      init: "Khởi tạo",
      isOCR: "Đã OCR",
      verified: "Đã xác thực",
      progress: "Đang xử lý",
      success: "Thành công",
      error: "Thất bại",
      sample: "Hồ sơ mẫu",
      activated: "Đã kích hoạt",
    },
    Type: {
      cccd: "CCCD",
      passport: "Hộ chiếu",
    },
    Platform: {
      multiple: "Đấu lô",
      single: "Đấu lẻ",
    },
    Message: {
      OcrSuccess: "Đã OCR thành công, thông tin đã cập nhật !",
      ProfileError:
        "Hồ sơ đang trạng thái lỗi, vui lòng OCR để cập nhật thông tin !",
      InvalidPicture: "Vui lòng nhập ít nhất 1 file ảnh !",
      InvalidPhone: "Số điện thoại phải ít nhất 6 chữ số !",
      InvalidEmail: "Email không hợp lệ!",
      Nation: "Vui lòng chọn quốc gia",
      InvalidNation:
        "Vui lòng chọn quốc gia để có thể cập nhật quê quán và nơi cấp",
      ConnectSuccessfully: "Đấu nối thành công",
      ConnectFailed: "Đấu nối thất bại",
      AutofillwithNation: "Chọn quốc tịch để cập nhật",
      EmptyField: "Vui lòng nhập đủ thông tin hồ sơ",
      SignatureError: "Vui lòng điền chữ ký",
      InvalidPortrait: "Ảnh chân dung không hợp lệ!",
      InvalidFront: "Ảnh hộ chiếu / CCCD không hợp lệ!",
      NationalityNote: 'Tự động điền dựa vào "Quốc tịch"',
      DateError: "Ngày phải trước ngày hiện tại",
      OCRSuccess: "OCR thành công",
      CreateSuccess: "Tạo hồ sơ thành công",
      CancelCreateConfirm: "Bạn có muốn thoát tiến trình tạo hồ sơ không?",
      CreateDescription: "Tạo bộ hồ sơ để đấu nối tay",
      ConnectDescription: "Đấu nối hồ sơ trực tiếp",
      LowBrightnessScore:
        "Độ sáng của ảnh hộ chiếu, chân dung hoặc videocall chưa đạt yêu cầu !",
      Brightness: {
        front: "Độ sáng của ảnh hộ chiếu chưa đạt yêu cầu",
        portrait: "Độ sáng của ảnh chân dung chưa đạt yêu cầu",
        videocall: "Độ sáng của videocall chưa đạt yêu cầu",
      },
      UploadMultipleSuccess: "Đấu lô hồ sơ thành công",
      UploadMultipleError: "Phải chọn file định dạng .zip, .rar, .tar",
      AddMissingImages: "Vui lòng bồ sung các hình ảnh",
      Reason: "Vui lòng nhập lý do",
    },
    TrackingResult: {
      ProfileNotFound: "Không tìm thấy hồ sơ",
      ProfileNotRegistered: "Chưa được đăng ký",
      NotVerified: "Chưa xác minh thông tin",
      Verified: "Đã xác minh thông tin",
      Progressing: "Đang xử lý",
      Success: "Đăng ký thành công",
      Fail: "Đăng ký thất bại",
      Activated: "Đã kích hoạt (gọi 900 thành công)",
      Inactivated: "Chưa kích hoạt (vui lòng gọi 900 để kích hoạt)",
    },
    TrackingMessage: {
      ProfileNotFound:
        "Không tìm thấy hồ sơ của bạn. Vui lòng kiểm tra thông tin tra cứu!",
      ProfileNotRegistered: "Sim chưa được đăng ký thông tin",
      NotVerified: "Hồ sơ chưa được xác minh thông tin",
      Verified: "Hồ sơ đã được xác minh thông tin",
      Progressing: "Hồ sơ của bạn đang được xử lý",
      Success: "Hồ sơ của bạn đã được đăng ký thành công",
      Fail: "Hồ sơ của bạn đăng ký đã thất bại",
      Nation: "Vui lòng chọn quốc gia",
      NationalityNote: 'Tự động điền dựa vào "Quốc tịch"',
      NoProfileOrImage: "Tra cứu yêu cầu ID hồ sơ hoặc ảnh Sim",
      Activated: "Sim đã kích hoạt thành công ( đã gọi qua 900 )",
      Inactivated: "Sim chưa kích hoạt ( vui lòng gọi 900 để kích hoạt )",
    },
  },
  RoamingRegistration: {
    Title: "Đăng ký gói cước cho User",
    ModalTitle: "Đăng ký gói cước cho thuê bao",
    Action: "Chọn gói",
    Phone: "Thuê bao cần đăng ký",
    Register: "Đăng ký",
    PhoneRegisteredListColumns: {
      Name: "Tên khách hàng",
      Phone: "Thuê bao đăng ký",
      Address: "Địa chỉ",
      Price: "Tổng tiền",
      Email: "Email",
    },
    Columns: {
      Name: "Tên gói",
      Code: "Mã gói",
      Type: "Loại gói",
      Duration: "Thời hạn",
      Capacity: "Dung lượng",
      Price: "Giá gói",
    },
    Placehoder: {
      Phone: "Vui lòng nhập số điện thoại...",
    },
    Message: {
      Success: "Đăng ký gói cước cho thuê bao thành công !",
      Failed: "Đăng ký gói cước cho thuê bao thất bại",
      Error: "Có lỗi xảy ra",
      InvalidPackageAndPhone:
        "Vui lòng chọn một gói cước và nhập thuê bao cần đăng ký !",
      InvalidPackage: "Vui lòng chọn một gói cước !",
      InvalidPhone: "Vui lòng nhập số thuê bao cần đăng ký gói !",
      RegisterSuccessfully: "Đăng ký gói cước cho thuê bao thành công !",
      PhoneRegistrationWarning:
        "Vui lòng nhập số thuê bao cần đăng ký để hiện danh sách gói phù hợp",
      PhoneRegistrationConfirm: "Xác nhận đăng ký gói",
      ForPhone: "cho thuê bao",
      BasePackagesExisted: "Thuê bao đang có gói nền",
      RemoveBasePackages: "vui lòng hủy gói nền trước khi đăng ký gói mới !",
      PackagesForSearchedPhone: "Danh sách gói cước cho thuê bao",
    },
  },
  VideoGeneration: {
    Labels: {
      Prompt: "Mong muốn",
      ImageNumber: "Số lượng ảnh",
      NumberFielity: "Tỉ lệ giống bản gốc",
      NativePrompt: "Không mong muốn",
      Generate: "Tạo hình videocall",
      Regenerate: "Tạo lại videocall",
      Results: "Kết quả",
      ChooseImage: "Chọn ảnh",
      Chosen: "Đã chọn !",
    },
    Placeholder: {
      Prompt: "Những điều bạn mong muốn khi tạo ảnh",
      NativePrompt: "Những điều bạn không mong muốn khi tạo ảnh",
      LesserThree: "Vui lòng nhập số lượng từ 1 đến 3 ảnh",
    },
  },
};
